// PDP Color Name Hover
// Swaps the colour name shown above the PDP swatch row while the shopper hovers
// (or keyboard-focuses) another colour swatch, and restores the selected
// colour's name on mouse-out. Purely visual — it never changes the product.
//
// Markup contract (snippets/main-product__info-blocks.liquid):
//   .product-page__color-swatches-container
//     span[data-color-name-display][data-default-color-name="Midnight Black"]
//     .product-page__color-swatches
//       .product-page__color-swatch[data-color-name][data-color]

(function () {
  const CONTAINER = '.product-page__color-swatches-container';
  const SWATCH = '.product-page__color-swatch';
  const DISPLAY = '[data-color-name-display]';

  // Fallback for any swatch rendered before data-color-name existed
  // (e.g. a stale sessionStorage cache): "midnight-black" -> "Midnight Black".
  function prettify(handle) {
    if (!handle) return '';
    return handle
      .split('-')
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }

  function labelFor(swatch) {
    if (!swatch) return '';
    return swatch.dataset.colorName || prettify(swatch.dataset.color);
  }

  function defaultLabel(container) {
    const display = container.querySelector(DISPLAY);
    const selected = container.querySelector(
      '.product-page__color-swatch--selected'
    );
    return (
      (display && display.dataset.defaultColorName) ||
      labelFor(selected) ||
      ''
    );
  }

  function setLabel(container, text) {
    const display = container.querySelector(DISPLAY);
    if (!display || !text) return;
    if (display.textContent.trim() === text.trim()) return;
    display.textContent = text;
  }

  function onPointerOver(event) {
    const swatch = event.target.closest(SWATCH);
    if (!swatch) return;
    const container = swatch.closest(CONTAINER);
    if (!container) return;
    const label = labelFor(swatch);
    if (label) setLabel(container, label);
  }

  function onPointerOut(event) {
    const swatch = event.target.closest(SWATCH);
    if (!swatch) return;
    const container = swatch.closest(CONTAINER);
    if (!container) return;
    // Ignore moves between the swatch and its own child label span.
    const next = event.relatedTarget;
    if (next && swatch.contains(next)) return;
    setLabel(container, defaultLabel(container));
  }

  function onContainerLeave(event) {
    const container = event.target.closest
      ? event.target.closest(CONTAINER)
      : null;
    if (!container) return;
    setLabel(container, defaultLabel(container));
  }

  function init() {
    // Delegated so lazy-loaded swatches and full product swaps are covered
    // without re-binding anything.
    document.addEventListener('mouseover', onPointerOver, true);
    document.addEventListener('mouseout', onPointerOut, true);
    document.addEventListener('focusin', onPointerOver, true);
    document.addEventListener('focusout', onPointerOut, true);

    // Safety net: pointer can leave the row quickly (or via scroll) without a
    // matching mouseout on the swatch itself.
    document.addEventListener(
      'mouseleave',
      (event) => {
        if (
          event.target &&
          event.target.classList &&
          event.target.classList.contains('product-page__color-swatches')
        ) {
          onContainerLeave(event);
        }
      },
      true
    );

    // After a swatch click swaps product-info, reset to the new colour.
    document.addEventListener('product-info:loaded', () => {
      document.querySelectorAll(CONTAINER).forEach((container) => {
        setLabel(container, defaultLabel(container));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
